export function formatBarChartData(item, i) {
  return {name: i + 1, RL: item.rl, QD: item.qd};
}

export function formatLineChartData(item, i) {
  return {
    name: `${item.date.substr(0, 10)} ${item.date.substr(11, 5)}`,
    RL: item.rl,
    QD: item.qd,
    RW: item.rw,
  };
}

export function formatBarChartDataAVG(item, i) {
  const keys = Object.keys(item);

  return keys.map((key) => ({
    name: item[key].date.substr(0, 10),
    RL: item[key].rl / (item[key].cnt),
    QD: item[key].qd / (item[key].cnt),
    RW: item[key].rw / (item[key].cnt),
  }));
}



// WEBPACK FOOTER //
// ./src/services/formatChartData.js